<template lang="html">
  <div>
    <van-nav-bar
      title="社区"
      />
      <div class="tab_box">
        <van-tabs v-model="active" @click="toService" sticky>
          <van-tab title="推荐">
            <ul class="tab_right_list">
              <router-link tag="li" class="tab_right_item" v-for="(d, v) in Recommend" :key="v" :to="`/article/${d.tid}`">
                <div class="item_left">
                  <h2>{{d.subject}}</h2>
                  <span>{{d.author}}</span>
                  <em>{{d.dateline}} 发布</em>
                </div>
                <div class="item_right">
                  <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${d.authorid}&size=middle`" alt="">
                </div>
              </router-link>
            </ul>
            <span class="loadMore" @click="recommendLoadMore">{{RecommendLoadMore}}</span>
          </van-tab>
          <van-tab title="谈天说地">
            <ul class="tab_right_list">
              <router-link tag="li" class="tab_right_item" v-for="(item, index) in Activities" :key="index" :to="`/article/${item.tid}`">
                <div class="item_left">
                  <h2>{{item.subject}}</h2>
                  <span>{{item.author}}</span>
                  <em>{{item.dateline}} 发布</em>
                </div>
                <div class="item_right">
                  <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${item.authorid}&size=middle`" alt="">
                </div>
              </router-link>
            </ul>
            <span class="loadMore" @click="activitiesLoadMore">{{ActivitiesLoadMore}}</span>
          </van-tab>
          <van-tab title="线下体验">
            <ul class="tab_right_list">
              <router-link tag="li" class="tab_right_item" v-for="(i, value) in Offline" :key="value" :to="`/article/${i.tid}`">
                <div class="item_left">
                  <h2>{{i.subject}}</h2>
                  <span>{{i.author}}</span>
                  <em>{{i.dateline}} 发布</em>
                </div>
                <div class="item_right">
                  <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${i.authorid}&size=middle`" alt="">
                </div>
              </router-link>
            </ul>
            <span class="loadMore" @click="offlineLoadMore">{{OfflineLoadMore}}</span>
          </van-tab>
          <van-tab title="服务支持">

          </van-tab>
           
        </van-tabs>
       
        
        
      </div>
      <div class="bottom_null_box"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import { NavBar } from 'vant'
import { Tab, Tabs } from 'vant'
import { Toast } from 'vant'

Vue.use(Toast)
Vue.use(Tab).use(Tabs)
Vue.use(NavBar)

export default {

  data (){
    return{
      active: 0,
      Activities: [],
      Offline: [],
      Application: [],
      Recommend: [],
      ActivitiesLoadMore: '点击加载更多',
      OfflineLoadMore: '点击加载更多',
      ApplicationLoadMore: '点击加载更多',
      RecommendLoadMore: '点击加载更多',
      ActivitiesPage: 1,
      OfflinePage: 1,
      ApplicationPage: 1,
      RecommendPage: 1
    }
  },
  beforeCreate() {
    Toast.loading({
      mask: false,
      message: '加载中...'
    })
  },
  created() {
    this.getCommunityActivitiesData()
    this.getOfflineData()
    this.getApplicationData()
    this.getCommunityRecommendData()
  },
  methods: {
    // -------获取推荐数据-------
    ///new_api.php?module=forum&mod=forumdisplay&fid=40&allforum=1&filter=digest&digest=1&orderby=lastpost
    getCommunityRecommendData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=40&allforum=1&filter=digest&digest=1&orderby=lastpost',
        method: 'GET',
        callback: (res) => {
          this.Recommend = res.data.list
        }
      })
    },
    toService(index,title){
      console.log(index)
      if(index==3){
        window.location.href="https://www.jmgo.com/mobile/m_server.php"
      }
      
    },
    // -------获取推荐分页数据-------
    recommendLoadMore() {
      let pages = this.RecommendPage + 1
      Toast.loading({
        mask: false,
        message: '加载中...'
      })
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=40&allforum=1&filter=digest&digest=1&orderby=lastpost&page'+ this.pages,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for (let i in res.data.list) {
              this.Recommend.push(res.data.list[i])
            }
          }else if (res.data.code == 300) {
            this.RecommendLoadMore = res.data.msg
          }
        }
      })
    },
    // -------获取社区活动数据-------
    getCommunityActivitiesData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=47&page=' + this.ActivitiesPage,
        method: 'GET',
        callback: (res) => {
          this.Activities = res.data.list
        }
      })
    },
    // -------获取社区活动分页数据-------
    activitiesLoadMore() {
      let page = this.ActivitiesPage + 1
      Toast.loading({
        mask: false,
        message: '加载中...'
      })
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=47&page=' + this.page,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for (let i in res.data.list) {
              this.Activities.push(res.data.list[i])
            }
          }else if (res.data.code == 300) {
            this.ActivitiesLoadMore = res.data.msg
          }
        }
      })
    },
    // -------获取线下体验会数据-------
    getOfflineData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=126&page=' + this.OfflinePage,
        method: 'GET',
        callback: (res) => {
          this.Offline = res.data.list
        }
      })
    },
    // -------获取线下体验会分页数据-------
    offlineLoadMore() {
      let page1 = this.OfflinePage + 1
      Toast.loading({
        mask: false,
        message: '加载中...'
      })
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=126&page=' + this.page1,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for (let n in res.data.list) {
              this.Offline.push(res.data.list[n])
            }
          }else if (res.data.code == 300) {
            this.OfflineLoadMore = res.data.msg
          }
        }
      })
    },
    // -------获取应用分享数据-------
    getApplicationData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=48&page=' + this.ApplicationPage,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.Application = res.data.list
          }
        }
      })
    },
    // -------获取应用分享分页数据-------
    applicationLoadMore() {
      let page2 = this.ApplicationPage + 1
      Toast.loading({
        mask: false,
        message: '加载中...'
      })
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&fid=48&page=' + this.page2,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for (let j in res.data.list) {
              this.Application.push(res.data.list[j])
            }
          }else if (res.data.code == 300) {
            this.ApplicationLoadMore = res.data.msg
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .m_server {
    -ms-flex: 1;
    flex: 1;
    cursor: pointer;
    padding: 0 5px;
    font-size: 14px;
    position: relative;
    color: #333;
    line-height: 44px;
    text-align: center;
    box-sizing: border-box;
    background-color: #fff;
    min-width: 0;
}
  .tab_box{
    .tab_right_list{
      padding: .1rem;
      background: #fff;
      .tab_right_item{
        display: flex;
        padding: .1rem 0;
        border-bottom: 1px solid #eaeaea;
        .item_left{
          flex: 1;
          h2{
            font-size: .14rem;
            color: #222;
            line-height: .2rem;
          }
          span{
            font-size: .12rem;
            color: #666;
            line-height: .3rem;
            margin-right: .1rem;
          }
          em{
            font-size: .12rem;
            color: #888;
            line-height: .3rem;
          }
        }
        .item_right{
          width: .7rem;
          height: .7rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .loadMore{
      display: block;
      width: 100%;
      height: .4rem;
      text-align: center;
      line-height: .4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Community/Community.vue